export enum ERC20Events {
  Approval = 'Approval',
  Transfer = 'Transfer',
}

export enum WalletNames {
  Coinbase = 'Coinbase Wallet',
  WalletConnect = 'WalletConnect',
  Metamask = 'MetaMask',
  Core = 'Core Wallet',
  Injected = 'Injected',
  WalletNotFound = 'Install Wallet Extention',
}

export enum MetamaskDownloadLinks {
  Chrome = 'https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn',
  Firefox = 'https://addons.mozilla.org/en-US/firefox/addon/ether-metamask/',
  Edge = 'https://microsoftedge.microsoft.com/addons/detail/metamask/ejbalbakoplchlghecdalmeeeajnimhm?hl=en-US',
  Opera = 'https://addons.opera.com/en-gb/extensions/details/metamask-10/',
  NativeWebsite = 'https://metamask.io/download/',
}

export enum CoreDownloadLinks {
  Chrome = 'https://chrome.google.com/webstore/detail/core-crypto-nft-wallet-ex/agoakfejjabomempkjlepdflaleeobhb',
  NativeWebsite = 'https://core.app/',
}

export type BigNumberT = {
  _hex: string;
  _isBigNumber: boolean;
};

export type WalletBalanceT = {
  decimals: number;
  formatted: string;
  symbol: string;
  value: BigNumberT;
};

export type InstrumentPairBalanceT = {
  baseCurrency: string;
  quoteCurrency: string;
};
